// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_l9-1";
export var rowFirst = "_l9-3";
export var rowLast = "_l9-5";
export var rowMiddle = "_l9-4";
export var ticketListScroll = "_l9-2";
export var ticketStack = "_l9-0";